<template>
  <router-link :to="item.link" class="hp-cloud-card">
    <!-- 悬浮背景色 - 从白色渐变到产品浅色 -->
    <div
      class="hp-cloud-card__hover"
      :style="{ background: `linear-gradient(90deg, #FFFFFF 0%, ${item.color}12 100%)` }"
    ></div>

    <div class="hp-cloud-card__inner">
      <!-- 图标和名称 -->
      <div class="hp-cloud-card__head">
        <div class="hp-cloud-card__icon" :style="{ backgroundColor: item.color }">
          <LucideIcon :name="item.icon" :size="20" />
        </div>
        <h4 class="hp-cloud-card__name">{{ item.name }}</h4>
        <!-- 箭头 -->
        <div class="hp-cloud-card__arrow" :style="{ backgroundColor: `${item.color}15` }">
          <LucideIcon name="arrow-up-right" :size="16" :style="{ color: item.color }" />
        </div>
      </div>

      <!-- 内容 -->
      <p class="hp-cloud-card__desc">{{ item.desc }}</p>
    </div>
  </router-link>
</template>

<script>
// 对应 projects-vue 的 src/components/sections/CloudCard.vue
import LucideIcon from '@/components/LucideIcon.vue'

export default {
  name: 'CloudCard',
  components: { LucideIcon },
  props: {
    item: { type: Object, required: true }
  }
}
</script>

<style lang="less" scoped>
@import './vars.less';

.hp-cloud-card {
  position: relative;
  display: block;
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid transparent;
  text-decoration: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    border-color: #fff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);

    .hp-cloud-card__hover {
      opacity: 1;
    }
    .hp-cloud-card__arrow {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

.hp-cloud-card__hover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hp-cloud-card__inner {
  position: relative;
}

.hp-cloud-card__head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.hp-cloud-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.hp-cloud-card__name {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: @hp-ink;
}

.hp-cloud-card__arrow {
  margin-left: auto;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0;
  transform: translateX(8px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.hp-cloud-card__desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.625;
  color: @hp-gray;
}
</style>
